/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import { default as FinGuidanceRoute } from 'embercom/routes/apps/app/automation/fin-ai-agent/guidance';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router';
import type ContentImportService from 'embercom/services/content-import-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';
import { taskFor } from 'ember-concurrency-ts';

export default class GuidanceStandaloneRoute extends FinGuidanceRoute {
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare contentImportService: ContentImportService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;

  analytics = {
    section: 'standalone',
    place: 'standalone.guidance',
  };

  async beforeModel() {}

  async model() {
    this.contentImportService.fetchAiContentLibrarySummary();
    this.contentImportService.fetchContentReviewSummary();

    let promises = [
      taskFor(this.reportingMetrics.setup).perform(),
      this.contentImportService.fetchContentIngestionState(),
      this.loadDescriptors(),
      this.loadCustomObjects(),
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.fin.guidelines_applied.guideline_ids',
        'conversation',
        true,
      ),
      this.store.findAll('ai-agent/escalation-rule'),
    ];

    promises.push(
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.fin.escalation_rules_applied.escalation_rule_ids',
        'conversation',
        true,
      ),
    );

    await Promise.all(promises);
    return super.model();
  }

  async loadDescriptors() {
    try {
      await this.store.findAll('conversation-attributes/descriptor');
    } catch (e) {
      console.error(e);
    }
  }

  async loadCustomObjects() {
    try {
      await this.store.findAll('custom-objects/object-type');
    } catch (e) {
      console.error(e);
    }
  }
}
